// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"aa40a0961c75763cfbff","883":"93a4b3e312ccd7d6c42a"}[chunkId] + ".js";
};